const TOKEN_KEY = 'auth_token'

const getToken = () => localStorage.getItem(TOKEN_KEY)

const authHeaders = () => {
  const token = getToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export { getToken, authHeaders }

export const supabase = null

export const signInWithEmail = async (email, password) => {
  try {
    const res = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    })
    const data = await res.json()
    if (!res.ok) {
      return { data: null, error: { message: data.error || 'Invalid credentials' } }
    }
    localStorage.setItem(TOKEN_KEY, data.token)
    return { data: { session: { token: data.token }, user: { email: data.email } }, error: null }
  } catch {
    return { data: null, error: { message: 'Network error. Please try again.' } }
  }
}

export const signUpWithEmail = async () => {
  return { data: null, error: { message: 'Self-registration is disabled.' } }
}

export const signOut = async () => {
  localStorage.removeItem(TOKEN_KEY)
  try {
    await fetch('/api/auth/logout', { method: 'POST', headers: authHeaders() })
  } catch {}
  return { error: null }
}

export const getCurrentUser = async () => {
  const token = getToken()
  if (!token) return null
  try {
    const res = await fetch('/api/auth/me', { headers: authHeaders() })
    if (!res.ok) { localStorage.removeItem(TOKEN_KEY); return null }
    return res.json()
  } catch {
    return null
  }
}

export const getSession = async () => {
  const token = getToken()
  return token ? { token } : null
}

export const changePassword = async (currentPassword, newPassword) => {
  const res = await fetch('/api/auth/password', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ currentPassword, newPassword }),
  })
  const data = await res.json()
  if (!res.ok) return { error: { message: data.error || 'Failed to update password' } }
  return { error: null }
}
